module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img61.9d728336.jpg";